import React from 'react';
import TituloTexto from '../../layout/titulo-texto';

export default function PagoNoCompletado() {
  return (
    <div>
      <TituloTexto texto={(
        <span>
          <b>
            <i className='fa fa-check' />
            {' '}
            LA RESERVA ESTARA VIGENTE POR 48HS.
            <br />
            <i className='fa fa-check' />
            {' '}
            NOS CONTACTAREMOS CONTIGO PARA COORDINAR EL PAGO Y FINALIZAR LA COMPRA.
            <br />
            <i className='fa fa-check' />
            {' '}
            PASADAS LAS 48HS  LA RESERVA SE CANCELARA AUTOMATICAMENTE.
            <br />
            <i className='fa fa-check' />
            {' '}
            LOS PRECIOS PARA LOS VIAJES INTERNACIONALES SON EN DOLARES ESTADOUNIDENSES EXPRESADOS EN PESOS ARGENTINOS AL TIPO DE CAMBIO DEL DIA DE LA CONFIRMACION DE LA RESERVA.
            <br />
            <i className='fa fa-check' />
            {' '}
            TEN EN CUENTA QUE EL PRECIO PUEDE VARIAR DE ACUERDO AL TIPO DE CAMBIO DEL DIA DE PAGO DEL PRODUCTO.
            <br />
          </b>
        </span>
      )}
      />
    </div>
  );
}
